import type { OpenPhotoCollectionProps } from '@lemonade-hq/uniclient-mobile-bridge';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export const PHOTO_COLLECTION_EXPLANATION_TEXT = '__photo_collection_explanation_text__';

export interface PhotoCollectionProps<TComponentAttributes extends string = string>
  extends UniclientBaseComponentProps {
  readonly attribute: TComponentAttributes;
  readonly photoCollection: OpenPhotoCollectionProps;
}

export type WizardPhotoCollectionProps<TComponentAttributes extends string = string> =
  PhotoCollectionProps<TComponentAttributes> & UniclientWizardComponentBase<'photo_collection'>;

export function photoCollection<TComponentAttributes extends string = string>(
  props: PhotoCollectionProps<TComponentAttributes>,
): WizardPhotoCollectionProps<TComponentAttributes> {
  return { ...props, type: 'photo_collection' };
}
